import type { PatientCommunicationTypeId } from '../../services/api/types.gen';

/** All communication type values (aligned with external EMR). */
export const PATIENT_COMMUNICATION_TYPES: readonly PatientCommunicationTypeId[] =
  [
    'Patient Communication',
    'CLM Welcome Call',
    'Physician Communication',
    'POC Doc Clarification',
    'Telehealth DC Tracking',
    'Telehealth Discontinue/Return to Office',
    'Telehealth Pickup/Setup',
    'CJR Report',
    'CLM Recert Call',
    'Wound Consult',
    'Frequency Order',
    'Frequency Change Order',
    'Frequency Discontinue Order',
    'Frequency Verbal Order',
    'PRN Order',
    'Physician Order',
  ];

/** Types that do not use an assigned clinician (matches backend). */
const TYPES_WITHOUT_ASSIGNABLE_CLINICIAN = new Set<PatientCommunicationTypeId>([
  'Patient Communication',
  'CLM Welcome Call',
  'Physician Communication',
  'POC Doc Clarification',
  'Telehealth DC Tracking',
  'Telehealth Discontinue/Return to Office',
  'Telehealth Pickup/Setup',
  'CJR Report',
  'CLM Recert Call',
  'Wound Consult',
]);

/** True when an assigned clinician is required for this type. */
export function patientCommunicationTypeRequiresAssignableClinician(
  t: PatientCommunicationTypeId
): boolean {
  return !TYPES_WITHOUT_ASSIGNABLE_CLINICIAN.has(t);
}
